// ============================================================
// Social — shared types for the friend / block system
// ============================================================
export const SOCIAL_MAX_FRIENDS = 100;
/** Page size for ALL social tabs (friends/pending/blocked/online). 24 = 4×6
 *  cells per page, matching the SocialHub grid layout. Caps simultaneous
 *  hero-portrait animations and keeps cell objects within Phaser's
 *  per-frame budget. */
export const SOCIAL_PAGE_SIZE = 24;
/** @deprecated Use `SOCIAL_PAGE_SIZE` — retained for one release for
 *  back-compat. The constant now applies to every tab, not just `online`. */
export const SOCIAL_ONLINE_PAGE_SIZE = SOCIAL_PAGE_SIZE;
export const SOCIAL_SEARCH_MIN = 2;
export const SOCIAL_SEARCH_MAX_RESULTS = 20;
//# sourceMappingURL=social.js.map